import map from '../components/map';
export default function contact_us() {
	var contactMap = document.querySelector("#contact-map"),
		mapPlace = {
			"lat": parseFloat(contactMap.getAttribute("data-place-lat"), 10),
			"lng": parseFloat(contactMap.getAttribute("data-place-lng"), 10)
		},
		mapCenter = {
			"lat": parseFloat(contactMap.getAttribute("data-center-lat"), 10),
			"lng": parseFloat(contactMap.getAttribute("data-center-lng"), 10)
		};

	map(contactMap.id, {
		API_KEY: contactMap.getAttribute("data-api-key"),
		place: mapPlace,
		center: window.isMobile ? mapPlace : mapCenter,
		title: contactMap.getAttribute("data-place-title")
	});

}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/contact_us.js
// module id = 12
// module chunks = 0